import styled from '@emotion/styled';

export const Scroll = styled.div`
  overflow-y: auto;
  width: 100%;
  height: 100%;
`;
